import React, { useState, useEffect } from 'react';

import Navbar from '../navbar/Navbar';
import Tabbar from '../navbar/Tabbar';
import axios from 'axios';

import tel from '../../assets/img/tel.png';
import employee from '../../assets/img/employee.png';


import * as Constants from '../../constants/global';

const Contactenos = () => {

    let empresa = JSON.parse(localStorage.getItem('empresa'));
    let sucursal = localStorage.getItem('sucursal');
    let codCliente = localStorage.getItem('codCliente');

    const [totalNavbar, setTotalNavbar] = useState();
    const [cantidad, setCantidad] = useState();

    const [nombreVendedor, setNombreVendedor] = useState("");
    const [telefonoVendedor, setTelefonoVendedor] = useState("");

    const [correoServicioAlCliente, setCorreoServicioAlCliente] = useState("");
    const [telefonoServicioCliente, setTelefonoServicioCliente] = useState("");
    const [textoLinea, setTextoLinea] = useState("");
    const [telefonoLineaGratuita, setTelefonoLineaGratuita] = useState("");
    const [paginaWeb, setPaginaWeb] = useState("");
    
    const loadInfoAyuda = async () => {
        setNombreVendedor(empresa.sucursal.NombreVendedor ? empresa.sucursal.NombreVendedor : "")
        setTelefonoVendedor(empresa.sucursal.TelefonoVendedor ? empresa.sucursal.TelefonoVendedor : "")

        setCorreoServicioAlCliente(empresa.sucursal.correoServicioAlCliente ? empresa.sucursal.correoServicioAlCliente : "")
        setTelefonoServicioCliente(empresa.sucursal.TelefonoServicioAlCliente ? empresa.sucursal.TelefonoServicioAlCliente : "")
        setTextoLinea(empresa.sucursal.textoLinea ? empresa.sucursal.textoLinea : "")
        setTelefonoLineaGratuita(empresa.sucursal.TelefonoLineaGratuita ? empresa.sucursal.TelefonoLineaGratuita : "")
        setPaginaWeb(empresa.sucursal.paginaWeb ? empresa.sucursal.paginaWeb : "")
    }
    
    const getCantidad = () => {

        Constants.calcularDescuento()
        let carrito = JSON.parse(localStorage.getItem(codCliente)) || {};

        let iva = 0;
        let total = 0;
        let descuentoTotal = 0;
        let cantidad = 0;

        Object.keys(carrito).map((item, i) => {

            cantidad += carrito[item]["cantidad"];

            let subtotal = (carrito[item]["cantidad"] * carrito[item]["precio"]);
            let descuento = (carrito[item]["descuentoAplicado"] ? carrito[item]["descuentoAplicado"] : 0);
            iva += ( (subtotal - descuento) * (carrito[item]["iva"] ? carrito[item]["iva"] / 100 : 0) );

            descuentoTotal += descuento
        })

        setCantidad(cantidad)

        Object.keys(carrito).map((item, i) => {
            total += carrito[item]["cantidad"] * carrito[item]["precio"];
        })

        setTotalNavbar(total - descuentoTotal + iva);
    }

    useEffect(() => {
        loadInfoAyuda();
        getCantidad();
    })

    return (
        <React.Fragment>
            <div className="navbar principal">
                <Navbar item={9} cantidad={cantidad} totalNavbar={totalNavbar} />
            </div>

            <div className="ayuda-list contactenos">
                <div className="seccion-ayuda">
                    
                    <img src={employee}></img>
                    <p className="nombre-vendedor font-ayuda">{nombreVendedor.toString().toUpperCase()}</p>
                    {/* <p className="telefono-vendedor font-ayuda">3146310397</p> */}
                    <p className="telefono-vendedor font-ayuda"><b>{telefonoVendedor}</b></p>
                    
                </div>
                <div className="seccion-ayuda">

                    <img src={tel}></img>

                    <p className="titulo-servicio-cliente font-ayuda">{correoServicioAlCliente}</p>
                    <p className="telefono-servicio-cliente font-ayuda">{telefonoServicioCliente}</p>
                    <p className="label-servicio-cliente font-ayuda">{textoLinea}</p>
                    <p className="tel-nal-servicio-cliente font-ayuda">{telefonoLineaGratuita}</p>
                    <p className="email-nal-servicio-cliente font-ayuda">{paginaWeb}</p>
                    
                </div>
            </div>

            <Tabbar item={9}/>
            
        </React.Fragment>
    )
}


export default Contactenos;